import { render, staticRenderFns } from "./simpleXgPlayer.vue?vue&type=template&id=20ce6894&scoped=true"
import script from "./simpleXgPlayer.vue?vue&type=script&lang=js"
export * from "./simpleXgPlayer.vue?vue&type=script&lang=js"
import style0 from "./simpleXgPlayer.vue?vue&type=style&index=0&id=20ce6894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce6894",
  null
  
)

export default component.exports